module.exports = __webpack_public_path__ + "static/media/shackleton_Chile.5d155d12.png";